import { render } from "./WeChatIcon.vue?vue&type=template&id=2b7860ed&scoped=true"
const script = {}

import "./WeChatIcon.vue?vue&type=style&index=0&id=2b7860ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7860ed"]])

export default __exports__